import cn from 'classnames'
import {Link} from 'react-router'
import styles from './metric-card.module.scss'

/**
 * @param {{
 *   label: string,
 *   value: number|string,
 *   unit?: string,
 *   trend?: string,
 *   trendDir?: 'up'|'down'|'flat',
 *   featured?: boolean,
 *   metricId?: string,
 *   eyebrow?: string,
 *   className?: string
 * }} props
 */
export function MetricCard({label, value, unit, trend, trendDir, featured = false, metricId, eyebrow, className}) {
    const formattedValue = typeof value === 'number'
        ? Number.isInteger(value) ? value : value.toFixed(1)
        : (value ?? '—')

    const body = (
        <>
            <div className={styles.head}>
                {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
                <p className={styles.label}>{label}</p>
            </div>
            <output
                className={styles.value}
                aria-label={unit ? `${formattedValue} ${unit}` : String(formattedValue)}
            >
                {formattedValue}
                {unit && <span className={styles.unit}>{unit}</span>}
            </output>
            {trend && (
                <p className={cn(styles.trend, trendDir && styles[`trend-${trendDir}`])}>{trend}</p>
            )}
        </>
    )

    const cardClass = cn(styles.card, {[styles.featured]: featured}, className)

    if (metricId)
        return <Link to={`/metrics/${metricId}`} className={cardClass}>{body}</Link>

    return <div className={cardClass}>{body}</div>
}
